// extracted by mini-css-extract-plugin
export default {"heading":"fC-z","signin":"gC-z","signupBtn":"hC-z","disabled":"iC-z"};